import 'angular:locale/data:en-GB';
import 'zone.js';(globalThis.$localize ??= {}).locale = "en-GB";
